import { toLiteral } from "../../../../helper/locale-utils";

export const getNotificationsItems = (history: any, _releaseNotes: any[], _lastReleaseReaded: string | null, tenantIsAvailability: boolean): any[] => {
  const items: any[] = [];

  if (!tenantIsAvailability) {
    items.push({
      header: toLiteral({ id: "header.tooltip.availability.title" }),
      body: toLiteral({ id: "header.tooltip.availability.2" }),
      type: "read",
    });
  }

  return items;
};
